import React from 'react'

const Maintenance = () => {
    const maintenanceStart = "June 17, 2024";
    const maintenanceEnd = "July 12, 2024";

    return (
        <div className="maintenance-div">
            <h1><span>Pats!</span> is getting a little tune up.</h1>
            <div>
                <p>We apologize for the inconvenience, but we're performing some maintenance from <strong>{maintenanceStart}</strong> to <strong>{maintenanceEnd}</strong>. We'll be back up soon!</p>
                <p>— The Pats! Team</p>
            </div>
        </div>
    );
}

export default Maintenance